import {ErrorHandler, inject, Injectable, Injector, NgZone} from "@angular/core";
import {MessageService} from "primeng/api";
import {HttpErrorResponse} from "@angular/common/http";
import {PlatformService} from "./services/platform.service";
import {AnalyticsService} from "./services/analytics.service";

@Injectable()
export class GlobalErrorHandle implements ErrorHandler {
  private readonly platformService = inject(PlatformService);
  private readonly injector = inject(Injector)

  constructor(private readonly messageService: MessageService,
              private readonly ngZone: NgZone) {
  }

  private shouldNotShowError(error: unknown): boolean {
    if (error instanceof Error) {
      if (error.name === 'AbortError' ||
        error.name.includes('History API') ||
        error.message.includes('History API') ||
        error.message.includes('Importing a module script failed') ||
        error.message.includes('Database deleted by request of the user') ||
        error.message.includes('During hydration Angular') ||
        error.message.includes('s.replaceAll is not a function')
      ) {
        // Ignore abort errors
        return true;
      }
    }
    return false;
  }

  handleError(error: unknown): void {
    this.ngZone.run(() => {
      let message: string;

      let visibleText = 'visible';
      let path: string | undefined;
      const online = navigator.onLine;
      let type: string;
      let status: string;
      let name: string;
      const preventShow = this.shouldNotShowError(error);

      if (preventShow) {
        visibleText = 'hidden';
      }

      if (error instanceof HttpErrorResponse && "message" in error.error) {
        message = error.error.message;
        path = error.url ?? undefined;
        type = 'http';
        status = error.status.toString();
        name = error.name;
        console.error(`A ${visibleText} http error occurred :`, message, error, error.error);
      } else if (error instanceof Error) {
          message = error.message;
          type = 'regular';
          name = error.name;
          status = 'none';
          console.error(`A ${visibleText} error occurred :`, message, error, error.stack);
      } else {
        message = 'Error unknown';
        console.error(`A ${visibleText} string error occurred :`, message, error);
        type = 'unknown';
        name = 'unknown';
        status = 'none';
      }

      if (this.platformService.isServer || preventShow) {
        return;
      }

      this.injector.get(AnalyticsService).sendEvent('visible-error', {
        error: message,
        online: online ? 'yes' : 'no',
        path: path ?? 'no-path',
        type,
        status,
        name
      });

      this.messageService.add({
        severity: 'error',
        summary: 'An error occurred',
        detail: message
      });
    });
  }
}
